//react
import React from 'react';

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CourseCreated } from 'redux/actions';

//firebase
import { db, storage } from 'assets/firebase';

//styles
import withStyles from "@material-ui/core/styles/withStyles";
import modalStyle from "assets/jss/material-kit-react/modalStyle.jsx";
//import styles from "assets/jss/material-kit-react/customCheckboxRadioSwitch.jsx";

//core
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import IconButton from "@material-ui/core/IconButton";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";

//components
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import PhotoCard from "components/PhotoCard/PhotoCard.jsx";

// @material-ui/icons
import Edit from "@material-ui/icons/Edit";
import Location from "@material-ui/icons/LocationOn";
import Photos from "@material-ui/icons/AddAPhotoOutlined";
import Calendar from "@material-ui/icons/CalendarTodayOutlined";

//fileUploader
import FileUploader from 'react-firebase-file-uploader';

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

//unique id generator
const uuidv4 = require('uuid/v4');

function Transition(props) {
    return <Slide direction="down" {...props} />;
  }
  
  class CourseEditor extends React.Component{
    constructor(props) {
      super(props);
      this.state = {
        modal: false,
        course: props.course
      };

      this.saveCourse = this.saveCourse.bind(this);
      this.updateCourse = this.updateCourse.bind(this);

      this.deletePhoto = this.deletePhoto.bind(this);
      this.updatePhoto = this.updatePhoto.bind(this);
      this.makeCoverPhoto = this.makeCoverPhoto.bind(this);
      this.makeThumbPhoto = this.makeThumbPhoto.bind(this);
    
    }

    handleClickOpen(modal) {
      var x = [];
      x[modal] = true;
      this.setState(x);
    }

    handleClose(modal) {
      var x = [];
      x[modal] = false;
      this.setState(x);
    }

    updateCourse(property, value) {
      var course = this.state.course;
      course[property] = value;
      this.setState({course: course});
    }

    addPhoto(url) {

      var course = this.state.course;
      if(!course.Photos) {
        course.Photos = [];
      }

      var photo = { ID: uuidv4(), Name: "New Photo", Description: "description", URL: url, Attribution:"", License:"", isCover: false, isThumb: false};

      course.Photos.push(photo);
      this.setState({course:course});
    }

    updatePhoto(photo) {
      var course = this.state.course;
      
      for(var i = 0; i < course.Photos.length; i++) {
        if(course.Photos[i].ID === photo.ID) {
          course.Photos[i] = photo;
          break;
        }
      }
    }

    deletePhoto(photo) {
      var course = this.state.course;

      for(var i = course.Photos.length - 1; i > -1; i--) {
        if(course.Photos[i].ID === photo.ID) {
          course.Photos.splice(i,1);
          break;
        }
      }

      this.setState({course:course});
    }

    makeCoverPhoto(photo) {
      var course = this.state.course;
      
      for(var i = 0; i < course.Photos.length; i++) {
        if(course.Photos[i].ID === photo.ID) {
          course.Photos[i].isCover = true;
        } else {
          course.Photos[i].isCover = false;
        }
      }
    }

    makeThumbPhoto(photo) {
      var course = this.state.course;
      
      for(var i = 0; i < course.Photos.length; i++) {
        if(course.Photos[i].ID === photo.ID) {
          course.Photos[i].isThumb = true;
        } else {
          course.Photos[i].isThumb = false;
        }
      }
    }

    saveCourse() {
    
      db.updateCourse(this.state.course.id, this.state.course).then(doc => {
        
        if(!this.state.course.id) { // i.e. if it's a new course
          //this.updateCourse("id",doc.id);
          //this.props.onCourseCreated(this.state.course);
          this.props.onChange();

          ReactGA.event({
            category: 'Course',
            action: 'Created a New Course'
          });
        } else { // i.e. an existing course

          this.props.onChange();
          
          ReactGA.event({
            category: 'Course',
            action: 'Updated a Course'
          });
        }
      });
    }
        
    // photos
    photoUploadStart = () => this.setState({isUploading: true, progress: 0});
    photoUploadProgress = (progress) => this.setState({progress});
    photoUploadError = (error) => {
        this.setState({isUploading: false});
        console.error(error);
    }
    photoUploadSuccess = (filename) => {
        this.setState({progress: 100, isUploading: false});
        
        storage.images.child(filename).getDownloadURL().then(url => this.addPhoto(url));
    };


    trim(value, maxLength) {
      if(value.length > maxLength)
          return value.substring(0,maxLength) + "...";
      else
          return value;
    }

    render() {

      const { classes } = this.props;

      return (
        <div>
          
          <IconButton
            aria-label="Edit"
            onClick={() => this.handleClickOpen("modal")}>
            <Edit
                className={
                    classes.tableActionButtonIcon + " " + classes.edit
                }
            />
          </IconButton>
          <Dialog
            classes={{
              root: classes.center,
              paper: classes.modal
            }}
            fullScreen
            open={this.state.modal}
            TransitionComponent={Transition}
            keepMounted
            onClose={() => this.handleClose("modal")}
            aria-labelledby="modal-slide-title"
            aria-describedby="modal-slide-description">

            <DialogTitle
              id="classic-modal-slide-title"
              disableTypography
              className={classes.modalHeader}
              style={{backgroundColor:"#efefef"}} >

              <GridContainer direction="row">
                <GridItem xs={12} sm={12} md={6}>
                  <h4 className={classes.modalTitle}>Edit Course</h4>
                </GridItem>
                <GridItem xs={12} sm={12} md={6} style={{textAlign:"right"}}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={this.state.course.IsVisible}
                        onChange={(e) => this.updateCourse("IsVisible", e.target.checked)}
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar
                        }}
                      />
                    }
                    classes={{
                      label: classes.label
                    }}
                    label="Visible"
                  />
                  <Button
                    onClick={() => this.handleClose("modal")}
                  >
                    Cancel
                  </Button>
                  &nbsp;
                  <Button
                    onClick={() => {
                        this.saveCourse();
                        this.handleClose("modal");
                      }}
                    color="success">
                    Save
                  </Button>
                </GridItem>
              </GridContainer>
            </DialogTitle>
            <DialogContent
              id="modal-slide-description"
              className={classes.modalBody}
              style={{backgroundColor:"#efefef"}}>
             <CustomTabs
                headerColor="success"
                tabs={[
                  {
                    tabName: "General",
                    tabIcon: Location,
                    tabContent: (
                      
                        <GridContainer direction="row">
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                              id="name"
                              labelText="Name"
                              value={this.state.course.Name}
                              inputProps={{
                                  placeholder: "Name"
                              }}
                              formControlProps={{
                                  fullWidth: true
                              }}
                              onChange={(e) => this.updateCourse("Name", e.target.value)}
                            />
                          </GridItem>
                          <GridItem xs={12} sm={12} md={12}>
                            <CustomInput
                                id="description"
                                labelText="Description"
                                value={this.state.course.Description}
                                inputProps={{
                                    placeholder: "Description",
                                    multiline:true
                                }}
                                formControlProps={{
                                    fullWidth: true
                                }}
                                onChange={(e) => this.updateCourse("Description", e.target.value)}
                            />
                          </GridItem>
                        </GridContainer>
                    )
                  },
                  {
                    tabName: "Photos",
                    tabIcon: Photos,
                    tabContent: (

                      <div>
                        <div style={{marginTop:"10px"}}>

                          <label style={{color: "#696969", cursor:"pointer"}}>
                            Upload a New Photo  
                          
                            <FileUploader
                              hidden 
                              accept="image/*"
                              name="photo"
                              randomizeFilename
                              storageRef={storage.images}
                              onUploadStart={this.photoUploadStart}
                              onUploadError={this.photoUploadError}
                              onUploadSuccess={this.photoUploadSuccess}
                              onProgress={this.photoUploadProgress}
                              />
                              
                          </label>
                        </div>

                        <GridContainer justify="flex-start">
                          {this.state.course.Photos.map(photo => (
                              <PhotoCard key={photo.id} photo={photo} 
                                onPhotoUpdated={this.updatePhoto} onPhotoMakeCover={this.makeCoverPhoto} 
                                onPhotoMakeThumb={this.makeThumbPhoto} onPhotoDelete={this.deletePhoto} />
                          ))}
                        </GridContainer>
                      </div>
                    )
                  },
                  {
                    tabName: "Calendar",
                    tabIcon: Calendar,
                    tabContent: (
                      <GridContainer style={{minHeight:"300px"}}>
                        <GridItem xs={12} sm={12} md={12}>
                            
                          </GridItem>
                      </GridContainer>
                    )
                  }
                ]}
              />

            </DialogContent>
            
            <DialogActions
              className={classes.modalFooter }
              style={{backgroundColor:"#efefef"}}>
              
            </DialogActions>
          </Dialog>
        </div>
      );
    }
  }
  
const mapStateToProps = state => {
  return state;
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onCourseCreated: CourseCreated }, dispatch);  
}

CourseEditor = connect(mapStateToProps, mapDispatchToProps)(CourseEditor);
export default withStyles(modalStyle)(CourseEditor);


// WEBPACK FOOTER //
// ./src/components/CourseEditor/CourseEditor.jsx